import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se usa para obtener listados de admisiones seg�n filtros
// CustomerId: Identificador de la Cliente
// UserId: Identificador del usuario
// CompanyId: Identificador de la compaa
// AccionPeticionValidar: Permisos de usuario para realizar la operacin
export const ListadoRequisitosInstitucionales = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/RequisitosInstitucionales/ListadoCliente', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

export const CrearRequisitosInstitucionalesCliente = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/ClientesRequisitosInstitucionales/Crear', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

export default ListadoRequisitosInstitucionales;